import { useEffect, useState, useRef } from "react";
import AccessTimeRounded from "@mui/icons-material/AccessTimeRounded";
import moment from "moment";
import AppointmentsApi from "../../../services/AppointmentsApi";
import ReportApi from "../../../services/ReportApi";
import { FaClinicMedical } from "react-icons/fa";
import ReactPaginate from "react-paginate";
import Loader from "../Loader";
import { useRecoilState } from "recoil";
import { setFollowupSlots } from "../../../recoil/atom/setFollowupSlots";
import { setReportsId } from "../../../recoil/atom/setReportId";
import { Link, useNavigate } from "react-router-dom";
import { MainButtonInput } from "../../../mainComponent/mainButtonInput";
import AuthApi from "../../../services/AuthApi";
import { MainSelect } from "../../../mainComponent/mainSelect";
import { THEME_COLOR } from "../../../config";
import { SecondaryButtonInput } from "../../../mainComponent/secondaryButtonInput";
import { setAppointmentId } from "../../../recoil/atom/setAppointmentId";
import { Tooltip } from "@mui/material";
import { Button, Modal } from "react-bootstrap";

export default function IncompleteAppointment(props) {
  const { doctorId } = props;
  const [patientHistoryData, setPatientHistoryData] = useState(null);
  const [clinics, setClinics] = useState([]);
  const [appointmentId, setappointmentId] = useRecoilState(setAppointmentId);
  const [selectedClinic, setSelectedClinic] = useState(null);
  const [followupSlots, setFollowupSlot] = useRecoilState(setFollowupSlots);
  const [reportId, setReportId] = useRecoilState(setReportsId);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [doctors, setDoctors] = useState([]);
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const { getAppointmentsDetails, deleteAppointment } = AppointmentsApi();
  const { MedicineReportData } = ReportApi();
  const { getDrInfo } = AuthApi();
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const clinicRef = useRef(selectedClinic);
  const paginationRef = useRef(currentPage);
  const doctorRef = useRef(selectedDoctor);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selectedAppointmentId, setSelectedAppointmentId] = useState(null);
  useEffect(() => {
    getPatientHistory(selectedClinic, currentPage, selectedDoctor);
    getAllClinics();
  }, []);

  const pageSize = 6;

  function getPatientHistory(selectedClinic, currentPage, selectedDoctor) {
    const data = {
      page: currentPage,
      pageSize: pageSize,
      status: "Inprogress",
      selectedClinic: selectedClinic,
      selectedDoctor: selectedDoctor,
    };
    setIsLoading(true);
    getAppointmentsDetails(doctorId, data)
      .then((result) => {
        setTotalPages(result.totalPages);
        setPatientHistoryData(result.pageIndex);
      })
      .catch((error) => {
        console.error("Failed to fetch data", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  const handlePageClick = (data) => {
    paginationRef.current = data.selected + 1;
    setCurrentPage(data.selected + 1);
    getPatientHistory(selectedClinic, data.selected + 1, selectedDoctor);
  };

  const handleClinicChange = (e) => {
    clinicRef.current = e.target.value;
    setSelectedClinic(e.target.value);
    getPatientHistory(e.target.value, currentPage, selectedDoctor);
  };

  const handleDoctorChange = (e) => {
    doctorRef.current = e.target.value;
    const doctorId = e.target.value;
    setSelectedDoctor(doctorId);
    getPatientHistory(selectedClinic, currentPage, doctorId);
  };

  const getAllClinics = () => {
    getDrInfo({ doctorId }).then((jsonRes) => {
      const clinicsData = jsonRes?.result[0]["clinicList"];
      console.log("clinicsData======>>>>", clinicsData);
      const doctorsData = jsonRes?.result[0]["doctorList"];
      doctorsData.push(jsonRes?.result[0]);
      setClinics(clinicsData);
      setDoctors(doctorsData);
    });
  };

  function saveData(item) {
    const patientId = item.dependentId ? item.dependentId : item.patientId;
    const bodyData = {
      doctorId: doctorId,
      patientId: patientId,
      patientAppointmentId: item._id,
      clinicId: item.clinicId,
      fees: item.fees,
    };
    MedicineReportData(bodyData).then((res) => {
      setFollowupSlot(res);
      setReportId(res._id);
      setappointmentId(item._id);
      navigate(`/appointments/${doctorId}/consultation/${res._id}`, {
        state: item.fees,
      });
    });
  }

  const confirmDeleteAppointment = async () => {
    try {
      await deleteAppointment(selectedAppointmentId);

      setOpenDeleteModal(false);
      setSelectedAppointmentId(null);

      getPatientHistory(
        clinicRef.current,
        paginationRef.current,
        doctorRef.current,
      );
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      {isLoading ? (
        <div className="loader-container">
          <Loader />
        </div>
      ) : (
        <>
          <div className="white-box mb-2">
            <div className="row" align="left">
              <div className="mr-4 mt-1">
                <label className="mb-2 font_weight" value="lab">
                  Find Appointments by Clinic
                </label>
                <div className="mt-2">
                  <MainSelect
                    value={selectedClinic}
                    onChange={handleClinicChange}
                  >
                    <option value="">Select Clinic</option>
                    {clinics &&
                      clinics.map((item, index) => (
                        <option
                          key={index}
                          value={item.clinicName}
                          className="form-control"
                        >
                          {item.clinicName}
                        </option>
                      ))}
                  </MainSelect>
                </div>
              </div>
              <div className="mr-4">
                <label className="mb-2 font_weight" value="lab">
                  Find Appointments by doctor
                </label>
                <div className="mt-2">
                  <MainSelect
                    value={selectedDoctor}
                    onChange={handleDoctorChange}
                  >
                    <option value="">Select doctor</option>
                    {doctors &&
                      doctors.map((item, index) => (
                        <option
                          key={index}
                          value={item._id}
                          className="form-control"
                        >
                          {item.name}
                        </option>
                      ))}
                  </MainSelect>
                </div>
              </div>
            </div>
          </div>
          {patientHistoryData && patientHistoryData.length > 0 ? (
            <>
              <div className="row">
                {patientHistoryData &&
                  patientHistoryData.map((details, i) => {
                    return (
                      <>
                        {!details.dependentId ? (
                          <div key={i} className="col-md-4 ">
                            <div className="cardDiv">
                              <span className="cardSpan">
                                <i className="icon-user color patientListIcon" />
                                <span className="patientName">
                                  {details?.patientDetails?.[0]?.name || "N/A"}
                                </span>
                              </span>
                              <span className="cardSpan">
                                <i className="icon-mobile-1 color patientListIcon" />
                                <span className="patinetInfo">
                                  {details?.patientDetails?.[0]?.mobile ||
                                    "N/A"}
                                </span>
                              </span>
                              <span className="cardSpan ">
                                <i className=" color patientListIcon ml-1 mr-2">
                                  <FaClinicMedical />{" "}
                                </i>
                                <span className="patinetInfo ">
                                  {" "}
                                  {details?.clinicList?.clinicName || "N/A"}
                                </span>
                              </span>
                              <span className="cardSpan">
                                <i className="pe-7s-date m-1 color patientListIcon" />
                                <span className="slotTime cardSpan">
                                  {moment(details.selectedDate)
                                    .format("YYYY-MM-DD")
                                    .toString()}
                                  ,{details.slotTime}
                                </span>
                              </span>

                              <span className="cardSpan">
                                <AccessTimeRounded
                                  style={{
                                    fontSize: 22,
                                    marginTop: 5,
                                    marginLeft: 2,
                                    marginRight: 2,
                                    color: THEME_COLOR,
                                  }}
                                />
                                {details.timeSlot} Min.
                              </span>
                              <span className="cardSpan">
                                <i className="icon-user-md color patientListIcon" />
                                <span className="patinetInfo">
                                  {details?.doctorDetails?.[0]?.name || ""}
                                </span>
                              </span>
                              {details["childrenbookingList"].map(
                                (item, index) => {
                                  return (
                                    <div
                                      key={index}
                                      className="slotTime cardSpan d-flex justify-content-between align-items-center"
                                    >
                                      <span
                                        key={index}
                                        className="slotTime cardSpan"
                                      >
                                        <span className="time  pr-1">
                                          Next followup:
                                        </span>
                                        {moment(item.selectedDate)
                                          .format("YYYY-MM-DD")
                                          .toString()}
                                        ,{item.slotTime}
                                      </span>
                                    </div>
                                  );
                                },
                              )}

                              <div className="row justify-end top_border">
                                <div className="mt-3 mr-2">
                                  <Link
                                    to={`report/${details.medicalReportId}`}
                                  >
                                    <MainButtonInput>
                                      Preview Report
                                    </MainButtonInput>
                                  </Link>
                                </div>
                                <div className="mt-3 mr-2">
                                  <Link onClick={() => saveData(details)}>
                                    <MainButtonInput>
                                      Resume Consultation
                                    </MainButtonInput>
                                  </Link>
                                </div>
                                <div className="">
                                  <Tooltip title="Delete Appointment" arrow>
                                    <Link
                                      to="#"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        setSelectedAppointmentId(details._id);
                                        setOpenDeleteModal(true);
                                      }}
                                      className="editbutton"
                                    >
                                      <i className="icon-trash-2 editbutton"></i>
                                    </Link>
                                  </Tooltip>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div key={i} className="col-md-4 ">
                            <div className="cardDiv">
                              <div className="cardSpan row ">
                                <div align="left" className="width_70">
                                  <i className=" icon-user color patientListIcon" />
                                  <span className=" patientName">
                                    {details["dependentDetails"][0].name}
                                  </span>
                                </div>
                                <div className="width_10" align="right">
                                  <span className="dependent">Dependent</span>
                                </div>
                              </div>
                              <span className="cardSpan">
                                <i className="icon-mobile-1 color patientListIcon" />
                                <span className="patinetInfo">
                                  {details["patientDetails"][0].mobile}
                                </span>
                              </span>
                              <span className="cardSpan ">
                                <i className=" color patientListIcon ml-1 mr-2">
                                  <FaClinicMedical />{" "}
                                </i>
                                <span className="patinetInfo ">
                                  {" "}
                                  {details["clinicList"].clinicName}
                                </span>
                              </span>
                              <span className="cardSpan time">
                                <i className="pe-7s-date m-1 color patientListIcon" />
                                <span className="slotTime">
                                  {moment(details.selectedDate)
                                    .format("YYYY-MM-DD")
                                    .toString()}
                                  ,{details.slotTime}
                                </span>
                              </span>
                              <span className="cardSpan">
                                <AccessTimeRounded
                                  style={{
                                    fontSize: 22,
                                    marginTop: 5,
                                    marginLeft: 2,
                                    color: { THEME_COLOR },
                                  }}
                                />
                                {details.timeSlot} Min.
                              </span>
                              <span className="cardSpan">
                                <i className="icon-user-md color patientListIcon" />
                                <span className="patinetInfo">
                                  {details?.doctorDetails?.[0]?.name || ""}
                                </span>
                              </span>
                              <div className="row justify-end top_border">
                                <div className="mt-3 mr-2">
                                  <Link
                                    to={`report/${details.medicalReportId}`}
                                  >
                                    <SecondaryButtonInput>
                                      Preview Report
                                    </SecondaryButtonInput>
                                  </Link>
                                </div>
                                <div className="mt-3 mr-2">
                                  <Link onClick={() => saveData(details)}>
                                    <MainButtonInput>
                                      Resume Consultation
                                    </MainButtonInput>
                                  </Link>
                                </div>
                                <div className="mt-3 mr-2">
                                  <Tooltip title="Delete Appointment" arrow>
                                    <Link
                                      to="#"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        setSelectedAppointmentId(details._id);
                                        setOpenDeleteModal(true);
                                      }}
                                      className="editbutton"
                                    >
                                      <i className="icon-trash-2 editbutton"></i>
                                    </Link>
                                  </Tooltip>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                    );
                  })}
              </div>
              <div className="marginleft">
                <ReactPaginate
                  breakLabel="..."
                  nextLabel="Next >"
                  onPageChange={handlePageClick}
                  pageRangeDisplayed={5}
                  pageCount={totalPages}
                  previousLabel="< Previous"
                  renderOnZeroPageCount={null}
                  marginPagesDisplayed={2}
                  containerClassName="pagination "
                  pageClassName="page-item"
                  pageLinkClassName="page-link"
                  previousClassName="page-item"
                  previousLinkClassName="page-link"
                  nextClassName="page-item"
                  nextLinkClassName="page-link"
                  activeClassName="active"
                  forcePage={currentPage - 1}
                />
              </div>
            </>
          ) : (
            <div className="clinicHistory font_weight">
              Appointments are not available
            </div>
          )}

          <div>
            <Modal
              show={openDeleteModal}
              onHide={() => setOpenDeleteModal(false)}
            >
              <Modal.Header closeButton>
                <Modal.Title>Are you sure?</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="alert modalColor">
                  {" "}
                  You want to permanently delete this appointment?
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="default"
                  className="appColor"
                  onClick={() => confirmDeleteAppointment(appointmentId)}
                >
                  Yes
                </Button>
                <Button
                  variant="default"
                  style={{ border: `1px solid ${THEME_COLOR} ` }}
                  onClick={() => setOpenDeleteModal(false)}
                >
                  No
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        </>
      )}
    </>
  );
}
